import {useCallback, useRef} from 'react';
import { sendMessage, sendBackMessage } from '../utils/messaging';
import { validateTransaction } from '../services/api';
import { PLATFORMS } from '../constants';
import {onReportEvent} from "../../../cardCapture/utils";
import {SDK_EVENT_KEYS} from "../../../../utils/logService";

export const useLivenessCallbacks = ({ platform, isMovil, transactionId, urlServiceLiveness, onFinish, onResult }) => {
    const resultLivenessRef = useRef(null);

    const handleComplete = useCallback(async () => {
        resultLivenessRef.current = true
    }, [platform, isMovil, transactionId, urlServiceLiveness, onFinish, onResult]);

    const handleError = useCallback((error) => {
        const errorData = {
            type: 'error-intern',
            step: error.code || 'sdk_error',
            data: error.code || 'sdk_error',
            message: error.message
        };

        onResult?.({ error: true, message: error.message });
        onReportEvent(SDK_EVENT_KEYS.SendToHost).catch()
        if (platform === PLATFORMS.WEB && !isMovil) {
            sendMessage(platform, isMovil, { origin: 'liveness', ...errorData });
        } else {
            sendMessage(platform, isMovil, errorData);
        }
        onFinish?.();
    }, [platform, isMovil, onResult, onFinish]);

    const handleClose = useCallback(async () => {
        const currentResult = resultLivenessRef.current;
        onReportEvent(SDK_EVENT_KEYS.SendToHost).catch()
        if (currentResult) {
            try {
                const result = await validateTransaction(urlServiceLiveness, transactionId);

                const data = {
                    success: true,
                    keyBucketImage: '',
                    keyBucketVideo: '',
                    data: {
                        score: 0.6,
                        quality: '',
                        isAlive: result.isAlive,
                        isFraud: result.isFraud,
                        probability: '',
                        threshold_probabillity: '',
                        threshold_quality: ''
                    },
                    videoBase64: '',
                    photoBase64: result.image,
                    videoBlob: {},
                    transactionId,
                };

                onResult?.(data);

                const baseMessage = { type: 'success', status: 'success', data };

                if (platform === PLATFORMS.WEB && !isMovil) {
                    sendMessage(platform, isMovil, { origin: 'liveness', ...baseMessage });
                } else {
                    sendMessage(platform, isMovil, baseMessage);
                }
            } catch (error) {
                const errorData = {
                    type: 'error-intern',
                    step: 'validation_failed',
                    data: 'validation_failed',
                    message: error.message
                };

                onResult?.({ error: true, message: error.message });

                if (platform === PLATFORMS.WEB && !isMovil) {
                    sendMessage(platform, isMovil, { origin: 'liveness', ...errorData });
                } else {
                    sendMessage(platform, isMovil, errorData);
                }
            }
            onFinish?.();
            return
        }
        sendBackMessage(platform, isMovil);
        onFinish?.();
    }, [platform, isMovil, onFinish]);

    return { handleComplete, handleError, handleClose };
};
